import defaultsDeep from 'lodash/defaultsDeep'
import actionTypes from 'constants/actionTypes'
import { DEFAULT_CONTENT_GENERATION_MODE } from 'actions/contentGeneration'
import type { ContentGenerationMode } from 'actions/contentGeneration'

interface ContentGenerationState {
  isFetching: boolean
  failed: boolean
  showModal: boolean
  status: string
  lastMode: ContentGenerationMode
  isFetchin?: boolean
}

interface ContentGenerationAction {
  type: string
  payload?: string
  mode?: ContentGenerationMode
}

const initialState: ContentGenerationState = {
  isFetching: false,
  failed: false,
  showModal: false,
  status: '',
  lastMode: DEFAULT_CONTENT_GENERATION_MODE,
}


export default (state: ContentGenerationState = initialState, action: ContentGenerationAction): ContentGenerationState => {
  if (action.type === actionTypes.CONTENT_GENERATION.OPEN_MODAL) {
    return defaultsDeep(
      {
        showModal: true
      },
      state
    )
  }
  if (action.type === actionTypes.CONTENT_GENERATION.CLOSE_MODAL) {
    return defaultsDeep(
      {
        showModal: false
      },
      state
    )
  }
  if (action.type === actionTypes.CONTENT_GENERATION.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true,
        failed: false,
        showModal: false,
        lastMode: action.mode || DEFAULT_CONTENT_GENERATION_MODE,
      },
      state
    )
  }
  if (action.type === actionTypes.CONTENT_GENERATION.SUCCESS) {
    const updated = defaultsDeep(
      {
        isFetching: false,
        status: ''
      },
      state
    )
    updated.isFetchin = false
    return updated
  }
  if (action.type === actionTypes.CONTENT_GENERATION.FAIL) {
    const updated = defaultsDeep(
      {
        isFetching: false,
        failed: true
      },
      state
    )
    updated.isFetching = false
    updated.failed = true
    return updated
  }
  if (action.type === actionTypes.CONTENT_GENERATION.SET_STATUS) {
    return defaultsDeep(
      {
        status: action.payload ?? ''
      },
      state
    )
  }
  return state
}
